export interface IHouseSummary {
  totalHousesFlats: number;
  activeHousesFlats: number;
  overdueHousesFlats: number;
}

export class HouseSummary {
  totalHousesFlats: number;
  activeHousesFlats: number;
  overdueHousesFlats: number;

  constructor(data: IHouseSummary) {
    this.totalHousesFlats = data.totalHousesFlats;
    this.activeHousesFlats = data.activeHousesFlats;
    this.overdueHousesFlats = data.overdueHousesFlats;
  }
}
